import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer" >
      <div className="container-fluid pdg-section-ch pb-md-3">
          <div className="row justify-content-space-around" style={{ marginRight:'0%'}}>
              <div className="col-md-9 col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'100%', color: 'var(--color-texto-blanco)'}}>
                    Hablemos de tu proyecto
                </h1>
                <p style={{width: '90%'}}> 
                  Estamos listos para convertir tus ideas en etiquetas de calidad.
                  ¡Contáctanos y comencemos!
                </p>
                <a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank" className="btn btn-custom my-5 p-3 gap-2" style={{background:'white', color:'var(--color-text-negro-light)'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                    </svg>
                    Solicita una cotización
                </a>
              </div>
              <div className="col-md-3 col-12 d-flex flex-row justify-content-end align-items-start p-0 cont-black">
                <div className='black-cont' style={{background:'var(--color-text-negro-light)', borderRadius: '20px 20px', padding:'5%'}}>
                    <p style={{fontWeight:'800', fontSize:'1rem', color:'white'}}>
                      ¿Qué producto es mejor para ti?
                    </p>
                    <p style={{fontWeight: '300', fontSize: '0.9rem', color:'white'}}>
                      Con nuestro test te ayudamos a saberlo.
                    </p>
                    <a href="/test" className="btn btn-custom p-3 gap-2 w-100" style={{background:'white', color:'var(--color-text-negro-light)'}}>
                        Realiza el test
                    </a>
                </div>
              </div>
          </div>
        
        <div className="row pb-md-4">
          {/* Columna 1: Links de navegación */}
          <div className="col-md-8 col-12 p-md-0 ps-0 py-5">
            <div className="d-flex flex-wrap justify-content-center menu-footer justify-content-md-start">
              <Link to="/" className="footer-link">Inicio</Link>
              <Link to="/nuestra-esencia" className="footer-link">Nuestra Esencia</Link>
              <Link to="/soluciones-industria" className="footer-link">Soluciones por Industria</Link>
              <Link to="/productos" className="footer-link">Productos</Link>
              <Link to="/maquinaria" className="footer-link">Maquinaria</Link>
              <Link to="/certificaciones" className="footer-link">Certificaciones</Link>
              <Link to="/historias-exito" className="footer-link">Historias de Éxito</Link>
              <Link to="/contacto" className="footer-link">Contacto</Link>
            </div>
          </div>

          {/* Columna 2: Redes sociales y copyright */}
          <div className="col-md-4 col-12">
            <div className="row">
              {/* Fila 1: Botones de redes sociales */}
              <div className="col-12 mb-3 p-0">
                <div className="d-flex cont-social justify-content-center justify-content-md-end">
                  <a href="https://www.facebook.com/MegaLabelOficial/" className="social-btn" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                    {/*<i className="fab fa-facebook-f"></i>*/}
                    {/*<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                    </svg>*/}
                    <strong style={{fontSize: '1.5rem'}}>f</strong>
                  </a>
                  {/*<a href="#" className="social-btn" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#" className="social-btn" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>*/}

                  <a href="https://www.linkedin.com/company/mega-label-oficial/" className="social-btn" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                    <strong style={{fontSize: '1.2rem'}}>in</strong>
                  </a>

                  <a href="https://www.youtube.com/@MegaLabelOficial" className="social-btn" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16">
                      <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
                    </svg>
                    {/*<i className="fa fa-youtube"></i>*/}
                  </a>
                </div>
              </div>

              {/* Fila 2: Copyright */}
              <div className="col-12 p-0">
                <div className="text-center text-md-end">
                  <p className="mb-0 copyright">
                    <span>© 2025 Mega Label. Todos los derechos reservados.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 